export const cabinPictures = [
  {
    display_name: `Cabin I`,
    location: require("./cabin_pictures/cabin_i.webp"),
  },
  {
    display_name: `Cabin K`,
    location: require("./cabin_pictures/cabin_k.webp"),
  },
  {
    display_name: `Cabin O5`,
    location: require("./cabin_pictures/cabin_o5.webp"),
  },
  {
    display_name: `Cabin O11`,
    location: require("./cabin_pictures/cabin_o11.webp"),
  },
  {
    display_name: `Cabin inside setup (cabins O11 and O12, see the next picture for the other cabins)`,
    location: require("./cabin_pictures/cabin_inside_pic2.webp"),
  },
  {
    display_name: `Cabin inside setup (cabins i, j, k, 03, 05, 09 all look like this inside)`,
    location: require("./cabin_pictures/cabin_inside.webp"),
  },
  {
    display_name: `Cabins I, J, K`,
    location: require("./cabin_pictures/cabin_i_j_k.jpg"),
  },
  {
    display_name: `Cabin J`,
    location: require("./cabin_pictures/cabin_j.jpg"),
  },
];
